module.exports = __webpack_public_path__ + "static/media/menu-burger.863da92d.svg";